import placesListModule from '../placesListModule';

function gameIcon(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.gameIcon
  };
}

placesListModule.directive('gameIcon', gameIcon);

export default gameIcon;
